export default __webpack_public_path__ + "static/media/pomaz.ea22783d.png";